import { useEffect } from "react"

export default function useTitle(titolo) {
    useEffect(()=> {
        if(titolo)
            document.title = titolo + ' | ASD Aquareal';
    }, [titolo])
    return null;
}